/*eslint-disable*/

//CLIENTS//
export const CHECK_CLIENT_IMPORT = "CHECK_CLIENT_IMPORT";
export const CHECK_CLIENT_IMPORT_ERROR = "CHECK_CLIENT_IMPORT_ERROR";
export const CLIENT_IMPORT = "CLIENT_IMPORT";
export const CLIENT_IMPORT_ERROR = "CLIENT_IMPORT_ERROR";
export const CHECK_RELATION_IMPORT = "CHECK_RELATION_IMPORT";
export const CHECK_RELATION_IMPORT_ERROR = "CHECK_RELATION_IMPORT_ERROR";
export const RELATION_IMPORT = "RELATION_IMPORT";
export const RELATION_IMPORT_ERROR = "RELATION_IMPORT_ERROR";
export const CHECK_DISTRIBUTOR_IMPORT = "CHECK_DISTRIBUTOR_IMPORT";
export const CHECK_DISTRIBUTOR_IMPORT_ERROR = "CHECK_DISTRIBUTOR_IMPORT_ERROR";
export const DISTRIBUTOR_IMPORT = "DISTRIBUTOR_IMPORT";
export const DISTRIBUTOR_IMPORT_ERROR = "DISTRIBUTOR_IMPORT_ERROR";
export const CHECK_SERVICE_PROVIDER_IMPORT = "CHECK_SERVICE_PROVIDER_IMPORT";
export const CHECK_SERVICE_PROVIDER_IMPORT_ERROR = "CHECK_SERVICE_PROVIDER_IMPORT_ERROR";
export const SERVICE_PROVIDER_IMPORT = "SERVICE_PROVIDER_IMPORT";
export const SERVICE_PROVIDER_IMPORT_ERROR = "SERVICE_PROVIDER_IMPORT_ERROR";
export const CHECK_ASSET_IMPORT = "CHECK_ASSET_IMPORT";
export const CHECK_ASSET_IMPORT_ERROR = "CHECK_ASSET_IMPORT_ERROR";
export const ASSET_IMPORT = "ASSET_IMPORT";
export const ASSET_IMPORT_ERROR = "ASSET_IMPORT_ERROR";
// SECTIONS
export const GET_SECTIONS = "@SECTIONS:  GET_SECTIONS";
export const SECTION_ERROR = "@SECTIONS:  SECTION_ERROR";
export const GET_ENUMS = "@SECTIONS:  GET_ENUMS";
export const GET_ENUMS_ERROR = "@SECTIONS:  GET_ENUMS_ERROR";
export const UPDATE_ENUMS = "UPDATE_ENUMS";
export const UPDATE_ENUMS_ERROR = "UPDATE_ENUMS_ERROR";
export const GET_ENUMS_FILTERED_ERROR = "GET_ENUMS_FILTERED_ERROR";
export const GET_ENUMS_FILTERED = "GET_ENUMS_FILTERED";
export const GET_SPECIFIC_STRUCTURE = "GET_SPECIFIC_STRUCTURE";
export const GET_SPECIFIC_STRUCTURE_ERROR = "GET_SPECIFIC_STRUCTURE_ERROR";
export const PUT_SPECIFIC_STRUCTURE = "PUT_SPECIFIC_STRUCTURE";
export const PUT_SPECIFIC_STRUCTURE_ERROR = "PUT_SPECIFIC_STRUCTURE_ERROR";

//SURVEY
export const SAVE_SURVEY = "@SURVEYS:  SAVE_SURVEY";
export const SAVE_SURVEY_ERROR = "@SURVEYS:  SAVE_SURVEY_ERROR";
export const UPDATE_SURVEY = "@SURVEYS:  UPDATE_SURVEY";
export const UPDATE_SURVEY_ERROR = "@SURVEYS:  UPDATE_SURVEY_ERROR";

// USER
export const UPDATE_USER_ME = "UPDATE_USER_ME";
export const UPDATE_USER_ME_ERROR = "UPDATE_USER_ME_ERROR";
export const GET_USERS = "GET_USERS";
export const ADD_USERS = "ADD_USERS";
export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_ERROR = "EDIT_USER_ERROR";
export const FIND_USER_TEAM = "FIND_USER_TEAM";
export const ADD_USER_TEAM = "ADD_USER_TEAM";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const GET_ME = "GET_ME";
export const GET_ME_ERROR = "GET_ME_ERROR";
export const EDIT_ME = "EDIT_ME";
export const EDIT_ME_ERROR = "EDIT_ME_ERROR";
export const USERS_ERROR = "USERS_ERROR";
export const PAGINATE_USERS = "PAGINATE_USERS";
export const PAGINATE_USERS_ERROR = "PAGINATE_USERS_ERROR";
export const GET_USER = "GET_USER";
export const GET_USER_ERROR = "GET_USER_ERROR";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const GET_USER_AUTH = "GET_USER_AUTH";
export const GET_USER_AUTH_ERROR = "GET_USER_AUTH_ERROR";
export const GET_AUTH_VALUES = "GET_AUTH_VALUES";
export const GET_AUTH_VALUES_ERROR = "GET_AUTH_VALUES_ERROR";
export const UPDATE_USERS_ROLE = "UPDATE_USERS_ROLE";
export const UPDATE_USERS_ROLE_ERROR = "UPDATE_USERS_ROLE_ERROR";
export const GET_CLIENTS_FILTERED = "GET_CLIENTS_FILTERED";
export const GET_CLIENTS_FILTERED_ERROR = "GET_CLIENTS_FILTERED_ERROR";
export const GET_USER_ROLE = "GET_USER_ROLE";
export const GET_USER_ROLE_ERROR = "GET_USER_ROLE_ERROR";
export const GET_BY_INTERNAL = "GET_BY_INTERNAL";
export const GET_BY_INTERNAL_ERROR = "GET_BY_INTERNAL_ERROR";
// CREATION USER
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";
export const CREATE_USER = "CREATE_USER";

// TEAM
export const GET_ALL_TEAMS = "GET_ALL_TEAMS";
export const GET_ALL_TEAMS_ERROR = "GET_ALL_TEAMS_ERROR";
export const ADD_TEAM = "ADD_TEAM";
export const EDIT_TEAM = "EDIT_TEAM";
export const EDIT_TEAM_ERROR = "EDIT_TEAM_ERROR";
export const ADD_TEAM_ERROR = "ADD_TEAM_ERROR";
export const GET_TEAM_ME = "GET_TEAM_ME";
export const GET_TEAM = "GET_TEAM";
export const GET_TEAM_ERROR = "GET_TEAM_ERROR";
export const GET_TEAM_ME_ERROR = "GET_TEAM_ME_ERROR";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const UPDATE_TEAM_ERROR = "UPDATE_TEAM_ERROR";
export const CREATE_TEAM = "CREATE_TEAM";
export const CREATE_TEAM_ERROR = "CREATE_TEAM_ERROR";
export const PAGINATE_TEAMS = "PAGINATE_TEAMS";
export const PAGINATE_TEAMS_ERROR = "PAGINATE_TEAMS_ERROR";
export const ADD_USER = "ADD_USER";
export const ADD_USER_ERROR = "ADD_USER_ERROR";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
export const GET_TEAMS_FILTERED = "GET_TEAMS_FILTERED";
export const GET_TEAMS_FILTERED_ERROR = "GET_TEAMS_FILTERED_ERROR";
export const ADD_TEAM_LOGO = "ADD_TEAM_LOGO";
export const ADD_TEAM_LOGO_ERROR = "ADD_TEAM_LOGO_ERROR";
// RULES
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_ALL_ROLES_ERROR = "GET_ALL_ROLES_ERROR";
export const PAGINATE_ROLES = "PAGINATE_ROLES";
export const PAGINATE_ROLES_ERROR = "PAGINATE_ROLES_ERROR";
export const GET_ROLE = "GET_ROLE";
export const GET_ROLE_ERROR = "GET_ROLE_ERROR";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_ERROR = "UPDATE_ROLE_ERROR";
export const GET_ME_AUTH = "GET_ME_AUTH";
export const GET_ME_AUTH_PENDING = "GET_ME_AUTH_PENDING";
export const GET_ME_AUTH_ERROR = "GET_ME_AUTH_ERROR";

// FUND
export const DELETE_FUND_IN_TEAM = "DELETE_FUND_IN_TEAM";
export const DELETE_FUND_IN_TEAM_ERROR = "DELETE_FUND_IN_TEAM_ERROR";
export const GET_ALL_FUNDS_IN_TEAM = "GET_ALL_FUNDS_IN_TEAM";
export const GET_ALL_FUNDS_IN_TEAM_ERROR = "GET_ALL_FUNDS_IN_TEAM_ERROR";
export const ADD_FUND_IN_TEAM = "ADD_FUND_IN_TEAM";
export const UPDATE_PART_TEXT_TRANSLATION = "UPDATE_PART_TEXT_TRANSLATION";
export const GET_TRANSLATION_BY_KEY = "GET_TRANSLATION_BY_KEY";
export const ADD_FUND_IN_TEAM_ERROR = "ADD_FUND_IN_TEAM_ERROR";
export const CREATE_FUND = "CREATE_FUND";
export const CREATE_FUND_ERROR = "CREATE_FUND_ERROR";
export const CREATE_TOAST = "CREATE_TOAST";
export const GET_TOASTS = "GET_TOASTS";
export const DELETE_TOAST = "DELETE_TOAST";
export const CREATE_TOAST_ERROR = "CREATE_TOAST_ERROR";
export const GET_ALL_FUNDS = "GET_ALL_FUNDS";
export const GET_ALL_FUNDS_ERROR = "GET_ALL_FUNDS_ERROR";
export const GET_FUND = "GET_FUND";
export const GET_FUND_ERROR = "GET_FUND_ERROR";

export const GET_PART = "GET_PART";
export const GET_PART_ERROR = "GET_PART_ERROR";
export const UPDATE_FUND = "UPDATE_FUND";
export const UPDATE_FUND_ERROR = "UPDATE_FUND_ERROR";
export const ADD_FUND_PART = "ADD_FUND_PART";
export const ADD_FUND_PART_ERROR = "ADD_FUND_PART_ERROR";
export const UPDATE_FUND_PART = "UPDATE_FUND_PART";
export const UPDATE_FUND_PART_ERROR = "UPDATE_FUND_PART_ERROR";
export const GET_BS_TEMPLATES = "GET_BS_TEMPLATES";
export const GET_BS_TEMPLATES_ERROR = "GET_BS_TEMPLATES_ERROR";
export const ADD_BS_TEMPLATES = "ADD_BS_TEMPLATES";
export const GET_TRANSFER_TEMPLATES = "GET_TRANSFER_TEMPLATES";
export const ADD_TRANSFER_TEMPLATES = "ADD_TRANSFER_TEMPLATES";
export const ADD_BS_TEMPLATES_ERROR = "ADD_BS_TEMPLATES_ERROR";
export const GET_TEMPLATE_BY_NAME = "GET_TEMPLATE_BY_NAME";
export const GET_TEMPLATE_BY_NAME_ERROR = "GET_TEMPLATE_BY_NAME_ERROR";
export const ADD_HTML_TEMPLATES = "ADD_HTML_TEMPLATES";
export const ADD_HTML_TEMPLATES_ERROR = "ADD_HTML_TEMPLATES_ERROR";
export const ADD_JSON_TEMPLATES = "ADD_JSON_TEMPLATES";
export const ADD_JSON_TEMPLATES_ERROR = "ADD_JSON_TEMPLATES_ERROR";
export const ADD_NEW_PARTY = "ADD_NEW_PARTY";
export const ADD_NEW_PARTY_ERROR = "ADD_NEW_PARTY_ERROR";
export const REMOVE_PARTY = "REMOVE_PARTY";
export const REMOVE_PARTY_ERROR = "REMOVE_PARTY_ERROR";
export const ADD_NEW_NATURE_TYPE = "ADD_NEW_NATURE_TYPE";
export const ADD_NEW_NATURE_TYPE_ERROR = "ADD_NEW_NATURE_TYPE_ERROR";
export const REMOVE_NATURE_TYPE = "REMOVE_NATURE_TYPE";
export const REMOVE_NATURE_TYPE_ERROR = "REMOVE_NATURE_TYPE_ERROR";
export const GET_ENGAGEMENT_LETTER_TEMPLATES =
  "GET_ENGAGEMENT_LETTER_TEMPLATES";
export const GET_ENGAGEMENT_LETTER_BY_NAME = "GET_ENGAGEMENT_LETTER_BY_NAME";
export const ADD_JSON_ENGAGEMENT_TEMPLATES = "ADD_JSON_ENGAGEMENT_TEMPLATES";
export const ADD_HTML_ENGAGEMENT_TEMPLATES = "ADD_HTML_ENGAGEMENT_TEMPLATES";

export const ADD_HTML_MIFID_TEMPLATES = "ADD_HTML_MIFID_TEMPLATES";
export const ADD_HTML_SEC_TEMPLATES = "ADD_HTML_SEC_TEMPLATES";
export const ADD_HTML_FCA_TEMPLATES = "ADD_HTML_FCA_TEMPLATES";
export const ADD_HTML_LSFIN_TEMPLATES = "ADD_HTML_LSFIN_TEMPLATES";


export const GET_MIFID_LETTER_BY_NAME = "GET_MIFID_LETTER_BY_NAME";
export const GET_SEC_LETTER_BY_NAME = "GET_SEC_LETTER_BY_NAME";
export const GET_FCA_LETTER_BY_NAME = "GET_FCA_LETTER_BY_NAME";
export const GET_LSFIN_LETTER_BY_NAME = "GET_LSFIN_LETTER_BY_NAME";

export const GET_MIFID_LETTER_TEMPLATES = "GET_MIFID_LETTER_TEMPLATES";
export const GET_SEC_LETTER_TEMPLATES = "GET_SEC_LETTER_TEMPLATES";
export const GET_FCA_LETTER_TEMPLATES = "GET_FCA_LETTER_TEMPLATES";
export const GET_LSFIN_LETTER_TEMPLATES = "GET_LSFIN_LETTER_TEMPLATES";

export const ADD_JSON_MIFID_TEMPLATES = "ADD_JSON_MIFID_TEMPLATES";
export const ADD_JSON_SEC_TEMPLATES = "ADD_JSON_SEC_TEMPLATES";
export const ADD_JSON_FCA_TEMPLATES = "ADD_JSON_FCA_TEMPLATES";
export const ADD_JSON_LSFIN_TEMPLATES = "ADD_JSON_LSFIN_TEMPLATES";

export const ADD_HTML_CONVENTION_TEMPLATES = "ADD_HTML_CONVENTION_TEMPLATES";
export const GET_CONVENTION_LETTER_BY_NAME = "GET_CONVENTION_LETTER_BY_NAME";
export const GET_CONVENTION_LETTER_TEMPLATES =
  "GET_CONVENTION_LETTER_TEMPLATES";
export const ADD_JSON_CONVENTION_TEMPLATES = "ADD_JSON_CONVENTION_TEMPLATES";
export const GET_INITIAL_CONTACT_CONTRACT_TEMPLATES =
  "GET_INITIAL_CONTACT_CONTRACT_TEMPLATES";
export const GET_INITIAL_CONTACT_CONTRACT_BY_NAME =
  "GET_INITIAL_CONTACT_CONTRACT_BY_NAME";
export const ADD_HTML_INITIAL_CONTACT_CONTRACT_TEMPLATES = "ADD_HTML_INITIAL_CONTACT_CONTRACT_TEMPLATES";
export const ADD_JSON_INITIAL_CONTACT_CONTRACT_TEMPLATES = "ADD_JSON_INITIAL_CONTACT_CONTRACT_TEMPLATES";
//SIGNERS
export const GET_ALL_ISSUER_SIGNERS = "GET_ALL_ISSUER_SIGNERS";
export const GET_ALL_ISSUER_SIGNERS_ERROR = "GET_ALL_ISSUER_SIGNERS_ERROR";
export const GET_ALL_PRODUCT_SIGNERS = "GET_ALL_PRODUCT_SIGNERS";
export const GET_ALL_PRODUCT_SIGNERS_ERROR = "GET_ALL_PRODUCT_SIGNERS_ERROR";
export const ADD_ISSUER_SIGNER = "ADD_ISSUER_SIGNER";
export const ADD_ISSUER_SIGNER_ERROR = "ADD_ISSUER_SIGNER_ERROR";
export const ADD_PRODUCT_SIGNER = "ADD_PRODUCT_SIGNER";
export const ADD_PRODUCT_SIGNER_ERROR = "ADD_PRODUCT_SIGNER_ERROR";
export const DELETE_ISSUER_SIGNER = "DELETE_ISSUER_SIGNER";
export const DELETE_ISSUER_SIGNER_ERROR = "DELETE_ISSUER_SIGNER_ERROR";
export const DELETE_PRODUCT_SIGNER = "DELETE_PRODUCT_SIGNER";
export const DELETE_PRODUCT_SIGNER_ERROR = "DELETE_PRODUCT_SIGNER_ERROR";
export const UPDATE_ISSUER_SIGNER = "UPDATE_ISSUER_SIGNER";
export const UPDATE_ISSUER_SIGNER_ERROR = "UPDATE_ISSUER_SIGNER_ERROR";
export const UPDATE_PRODUCT_SIGNER = "UPDATE_PRODUCT_SIGNER";
export const UPDATE_PRODUCT_SIGNER_ERROR = "UPDATE_PRODUCT_SIGNER_ERROR";

// CLIENTS
export const GET_CLIENTS = "GET_CLIENTS";
export const GET_CLIENTS_ERROR = "GET_CLIENTS_ERROR";
export const CREATE_PERSON = "CREATE_PERSON";
export const CREATE_PERSON_ERROR = "CREATE_PERSON_ERROR";
export const UPDATE_PERSON_ERROR = "UPDATE_PERSON_ERROR";
export const UPDATE_PERSON = "UPDATE_PERSON";
export const ADD_CLIENT_LOGO = "ADD_CLIENT_LOGO";
export const ADD_CLIENT_LOGO_ERROR = "ADD_CLIENT_LOGO_ERROR";
export const GET_CLIENT_LOGO = "GET_CLIENT_LOGO";
export const GET_CLIENT_LOGO_ERROR = "GET_CLIENT_LOGO_ERROR";

// RISK
export const GET_RISK_PROFILES = "@RISK: \n GET_RISK_PROFILES";
export const GET_RISK_PROFILES_ERROR = "@RISK: \n GET_RISK_PROFILES_ERROR";
export const GET_ALL_RISK_CRITERIAS_CONFIGURATION =
  "@RISK: \n GET_ALL_RISK_CRITERIAS_CONFIGURATION";
export const GET_ALL_RISK_CRITERIAS_CONFIGURATION_ERROR =
  "@RISK: \n GET_ALL_RISK_CRITERIAS_CONFIGURATION_ERROR";
export const GET_ALL_RISK_CRITERIAS = "@RISK: \n GET_ALL_RISK_CRITERIAS";
export const GET_ALL_RISK_CRITERIAS_ERROR =
  "@RISK: \n GET_ALL_RISK_CRITERIAS_ERROR";
export const UPDATE_RISK_CRITERIA_VALUES =
  "@RISK: \n UPDATE_RISK_CRITERIA_VALUES";
export const UPDATE_RISK_CRITERIA_VALUES_ERROR =
  "@RISK: \n UPDATE_RISK_CRITERIA_VALUES_ERROR";
export const ADD_CRITERIA = "@RISK: \n ADD_CRITERIA";
export const ADD_CRITERIA_ERROR = "@RISK: \n ADD_CRITERIA_ERROR";
export const DELETE_CRITERIA = "@RISK: \n DELETE_CRITERIA";
export const DELETE_CRITERIA_ERROR = "@RISK: \n DELETE_CRITERIA_ERROR";
export const GET_QUESTIONS_BY_CRITERIA = "@RISK: \n GET_QUESTIONS_BY_CRITERIA";
export const GET_QUESTIONS_BY_CRITERIA_ERROR =
  "@RISK: \n GET_QUESTIONS_BY_CRITERIA_ERROR";
export const GET_QUESTIONS_CONFIGURATION =
  "@RISK: \n GET_QUESTIONS_CONFIGURATION";
export const GET_QUESTIONS_CONFIGURATION_ERROR =
  "@RISK: \n GET_QUESTIONS_CONFIGURATION_ERROR";
("UPDATE_RISK_CRITERIA_VALUES_ERROR");
export const UPDATE_RISK_PROFILES = "UPDATE_RISK_PROFILES";
export const UPDATE_RISK_PROFILES_ERROR = "UPDATE_RISK_PROFILES_ERROR";
export const DELETE_RISK_PROFILES = "DELETE_RISK_PROFILES";
export const DELETE_RISK_PROFILES_ERROR = "DELETE_RISK_PROFILES_ERROR";
export const ADD_RISK_PROFILES = "ADD_RISK_PROFILES";
export const ADD_RISK_PROFILES_ERROR = "ADD_RISK_PROFILES_ERROR";
export const ADD_QUESTIONS_CONFIGURATION = "ADD_QUESTIONS_CONFIGURATION";
export const ADD_QUESTIONS_CONFIGURATION_ERROR =
  "ADD_QUESTIONS_CONFIGURATION_ERROR";
export const DELETE_QUESTIONS_CONFIGURATION = "DELETE_QUESTIONS_CONFIGURATION";
export const DELETE_QUESTIONS_CONFIGURATION_ERROR =
  "DELETE_QUESTIONS_CONFIGURATION_ERROR";
export const GET_ALL_PROPERTIES = "GET_ALL_PROPERTIES";
export const GET_ALL_PROPERTIES_ERROR = "GET_ALL_PROPERTIES_ERROR";
export const EDIT_PROPERTIES = "EDIT_PROPERTIES";
export const EDIT_PROPERTIES_ERROR = "EDIT_PROPERTIES_ERROR";
export const EDIT_PROPERTIES_LIST = "EDIT_PROPERTIES_LIST";
export const EDIT_PROPERTIES_LIST_ERROR = "EDIT_PROPERTIES_LIST_ERROR";
export const GET_ALL_QUESTIONS_CONFIGURATION =
  "GET_ALL_QUESTIONS_CONFIGURATION";
export const GET_ALL_QUESTIONS_CONFIGURATION_ERROR =
  "GET_ALL_QUESTIONS_CONFIGURATION_ERROR";
export const GET_ALL_EMAIL_TEMPLATES = "GET_ALL_EMAIL_TEMPLATES";
export const GET_ALL_EMAIL_TEMPLATES_ERROR = "GET_ALL_EMAIL_TEMPLATES_ERROR";
export const GET_EMAIL_TEMPLATE_BY_TYPE = "GET_EMAIL_TEMPLATE_BY_TYPE";
export const GET_EMAIL_TEMPLATE_BY_TYPE_ERROR =
  "GET_EMAIL_TEMPLATE_BY_TYPE_ERROR";
export const ADD_EMAIL_TEMPLATE_BY_TYPE = "ADD_EMAIL_TEMPLATE_BY_TYPE";
export const ADD_EMAIL_TEMPLATE_BY_TYPE_ERROR =
  "ADD_EMAIL_TEMPLATE_BY_TYPE_ERROR";
export const EDIT_QUESTIONS_CONFIGURATION_VALUES =
  "EDIT_QUESTIONS_CONFIGURATION_VALUES";
export const EDIT_QUESTIONS_CONFIGURATION_VALUES_ERROR =
  "EDIT_QUESTIONS_CONFIGURATION_VALUES_ERROR";
export const ADD_NET_ASSET_VALUE = "ADD_NET_ASSET_VALUE";
export const ADD_NET_ASSET_PART_VALUE = "ADD_NET_ASSET_PART_VALUE";
export const ADD_NET_ASSET_VALUE_ERROR = "ADD_NET_ASSET_VALUE_ERROR";
export const DELETE_NET_ASSET_VALUE = "DELETE_NET_ASSET_VALUE";
export const DELETE_NET_ASSET_PART_VALUE = "DELETE_NET_ASSET_PART_VALUE";
export const DELETE_NET_ASSET_VALUE_ERROR = "DELETE_NET_ASSET_VALUE_ERROR";
export const GET_NET_ASSET_VALUE = "GET_NET_ASSET_VALUE";
export const GET_NET_ASSET_PART_VALUE = "GET_NET_ASSET_PART_VALUE";
export const GET_NET_ASSET_VALUE_ERROR = "GET_NET_ASSET_VALUE_ERROR";
export const GET_COLORS = "GET_COLORS";
export const GET_COLORS_ERROR = "GET_COLORS_ERROR";


// DOCUMENTS
export const GET_ROOT_DOCUMENTS_AND_DIRECTORIES =
  "GET_ROOT_DOCUMENTS_AND_DIRECTORIES";
export const GET_ROOT_DOCUMENTS_AND_DIRECTORIES_ERROR =
  "GET_ROOT_DOCUMENTS_AND_DIRECTORIES_ERROR";
export const GET_DIRECTORY_DOCUMENTS = "GET_DIRECTORY_DOCUMENTS";
export const GET_DIRECTORY_DOCUMENTS_ERROR = "GET_DIRECTORY_DOCUMENTS_ERROR";
export const GET_DOCUMENT = "GET_DOCUMENT";
export const GET_DOCUMENT_ERROR = "GET_DOCUMENT_ERROR";
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const ADD_DOCUMENT_ERROR = "ADD_DOCUMENT_ERROR";
export const ADD_DIRECTORY = "ADD_DIRECTORY";
export const ADD_DIRECTORY_ERROR = "ADD_DIRECTORY_ERROR";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const DELETE_DOCUMENT_ERROR = "DELETE_DOCUMENT_ERROR";
export const DELETE_DIRECTORY = "DELETE_DIRECTORY";
export const DELETE_DIRECTORY_ERROR = "DELETE_DIRECTORY_ERROR";
export const ADD_DOCUMENT_AND_DIRECTORY = "ADD_DOCUMENT_AND_DIRECTORY";
export const ADD_DOCUMENT_AND_DIRECTORY_ERROR =
  "ADD_DOCUMENT_AND_DIRECTORY_ERROR";
export const ADD_DOCUMENT_FUND = "ADD_DOCUMENT_FUND";
export const ADD_DOCUMENT_FUND_ERROR = "ADD_DOCUMENT_FUND_ERROR";
export const GET_DOCUMENT_FUND = "GET_DOCUMENT_FUND";
export const GET_DOCUMENT_FUND_ERROR = "GET_DOCUMENT_FUND_ERROR";
export const DOCUMENT_IMPORT = "DOCUMENT_IMPORT";
export const DOCUMENT_IMPORT_ERROR = "DOCUMENT_IMPORT_ERROR";
export const CHECK_DOCUMENT_IMPORT = "CHECK_DOCUMENT_IMPORT";
export const CHECK_DOCUMENT_IMPORT_ERROR = "CHECK_DOCUMENT_IMPORT_ERROR";
export const GET_DOCUMENTS_PART = "GET_DOCUMENTS_PART";
export const ADD_DOCUMENT_PART = "ADD_DOCUMENT_PART";
export const ADD_ENVELOPE_PART = "ADD_ENVELOPE_PART";
export const GET_DOCUMENT_PART = "GET_DOCUMENT_PART";
export const DELETE_ENVELOPE_PART = "DELETE_ENVELOPE_PART";
export const DELETE_DOCUMENT_PART = "DELETE_DOCUMENT_PART";

// Available Language
export const GET_AVAILABLE_LANGUAGE = "GET_AVAILABLE_LANGUAGE";
export const GET_AVAILABLE_LANGUAGE_ERROR = "GET_AVAILABLE_LANGUAGE_ERROR";
